import _ from "lodash";
import GFunc from "./__GFunc";
import LocaleX from "./LocaleX";

class AlertX {

  /**
   * @typedef {import("IZOX/ARCS/Overlay/_gears/SnackAlert").alertSeverity} alertSeverity 
   * 
   */

  /**
   * 
   * @param {alertSeverity} severity 
   */
  static TryAgainLater(severity = "error"){
    GFunc.Alert({
      EN: "Please try again later.",
      TC: "請稍後再試"
    }, severity);
  }

  /**
   * 
   * @param {alertSeverity} severity 
   */
  static RequiredFields(severity = "error"){
    GFunc.Alert({
      EN: "Some fields are empty.",
      TC: "有些欄位沒有填妥"
    }, severity);
  }

  /**
   * 
   * @param {alertSeverity} severity 
   */
  static PasswordNotMatch(severity = "error"){
    GFunc.Alert({
      EN: "Password not match.",
      TC: "密碼不匹配"
    }, severity);
  }

  static AllErrors(allErrors, severity = "error", duration = undefined){
    let errors = _.map(allErrors, o => LocaleX.Parse(o)).join("\n");
    GFunc.Alert(errors, severity, duration);
  }

}

export default AlertX;